module.exports = __webpack_public_path__ + "static/media/icon_image-23.29fe8866.svg";